import { useEffect, useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import {
  faBookOpen,
  faBook,
  faChalkboardTeacher,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ToastError from "../../../../NotificationToast/ToastError";

import DetailEkskulPage from "./subpage/DetailEkskulPage";

export default function Ekstrakurikuler() {
  document.title = "Ekstrakurikuler";

  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  const [isFetching, setIsFetching] = useState(true);

  const [selectedMatpel, setSelectedMatpel] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [getData, setGetData] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);

  const [selectedSemesterId, setSelectedSemesterId] =
    useState("");

  const [
    selectedAcademicYearId,
    setSelectedAcademicYearId,
  ] = useState("");

  const getToken = () => {
    return localStorage.getItem("token") || "";
  };

  const getLoginUser = () => {
    const keys = [
      "user",
      "user_data",
      "data_user",
      "auth_user",
    ];

    for (const key of keys) {
      try {
        const raw = localStorage.getItem(key);

        if (raw) {
          return JSON.parse(raw);
        }
      } catch (error) {
        // Lewati data localStorage yang bukan JSON.
      }
    }

    return {};
  };

  const getTeacherId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("teacherID") ||
      localStorage.getItem("id_teacher") ||
      localStorage.getItem("ysb_teacher_id") ||
      user?.teacherID ||
      user?.id_teacher ||
      user?.ysb_teacher_id ||
      user?.teacher_id ||
      user?.teacher?.id ||
      user?.teacher_data?.id ||
      user?.data?.teacherID ||
      user?.data?.id_teacher ||
      user?.data?.ysb_teacher_id ||
      user?.data?.teacher?.id ||
      ""
    );
  };

  const getBranchId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("ysb_branch_id") ||
      user?.ysb_branch_id ||
      ""
    );
  };

  const getSchoolId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("ysb_school_id") ||
      user?.ysb_school_id ||
      ""
    );
  };

  const getSemesterArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const getMatpelArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data_matpel)) {
      return responseData.data.data_matpel;
    }

    if (
      Array.isArray(
        responseData?.data?.data?.data_matpel
      )
    ) {
      return responseData.data.data.data_matpel;
    }

    if (Array.isArray(responseData?.data?.ysb_matpel)) {
      return responseData.data.ysb_matpel;
    }

    if (
      Array.isArray(
        responseData?.data?.data?.ysb_matpel
      )
    ) {
      return responseData.data.data.ysb_matpel;
    }

    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const getSemesterLabel = (item) => {
    return `${item?.name_year || "-"} (Semester ${
      item?.semester || "-"
    })`;
  };

  const getSemesterData = async () => {
    setIsFetching(true);

    try {
      const token = getToken();

      const response = await APIMS.get(
        "/api/access/semesters",
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          params: {
            page: 1,
            limit: 100,
            ascending: 0,
            search: "",
          },
        }
      );

      const rows = getSemesterArrayFromResponse(
        response?.data
      );

      setSemesterOptions(rows);

      const activeSemester =
        rows.find(
          (item) => Number(item?.status) === 1
        ) || rows[0];

      if (activeSemester) {
        setSelectedSemesterId(
          activeSemester?.id || ""
        );

        setSelectedAcademicYearId(
          activeSemester?.ysb_academic_year_id || ""
        );
      } else {
        setIsFetching(false);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data semester",
      });

      setIsFetching(false);
    }
  };

  const getMatpelTeacherData = async ({
    semesterId,
    academicYearId,
  }) => {
    if (!semesterId || !academicYearId) {
      setGetData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const token = getToken();
      const teacherId = getTeacherId();

      if (!teacherId) {
        ToastError.fire({
          icon: "error",
          title:
            "ID teacher tidak ditemukan. Silakan login ulang.",
        });

        setGetData([]);
        setIsFetching(false);
        return;
      }

      const response = await APISD.request({
        method: "GET",
        url: "/api/ekstrakurikuler-assignments",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: semesterId,
          ysb_branch_id: getBranchId(),
          ysb_school_id: getSchoolId(),
          ysb_teacher_id: teacherId,
        },
      });

      const rows = getMatpelArrayFromResponse(
        response?.data
      );

      const normalizedRows = rows.flatMap(
        (item, index) => {
          const rawKelasList = Array.isArray(
            item?.kelas_list
          )
            ? item.kelas_list
            : [];

          const rawAssignments = Array.isArray(
            item?.assignments
          )
            ? item.assignments
            : [];

          const rawTotalSiswaGrade = Array.isArray(
            item?.total_siswa_grade
          )
            ? item.total_siswa_grade
            : [];

          const matpelId =
            item?.ysb_matpel_id ||
            item?.id ||
            `matpel-${index}`;

          const namaMatpel =
            item?.name_matpel ||
            item?.nama_matpel ||
            item?.matpel_name ||
            "-";

          const kelasList = rawKelasList.map(
            (kelas) => {
              const assignment =
                rawAssignments.find(
                  (assign) =>
                    assign?.assignment_id ===
                    kelas?.assignment_id
                );

              return {
                assignment_id:
                  kelas?.assignment_id ||
                  assignment?.assignment_id ||
                  "",

                ysb_kelas_id:
                  kelas?.ysb_kelas_id ||
                  assignment?.ysb_kelas_id ||
                  "",

                ysb_grade_level_id:
                  kelas?.ysb_grade_level_id ||
                  assignment?.ysb_grade_level_id ||
                  "",

                ysb_branch_id:
                  kelas?.ysb_branch_id ||
                  assignment?.ysb_branch_id ||
                  item?.ysb_branch_id ||
                  "",

                ysb_school_id:
                  kelas?.ysb_school_id ||
                  assignment?.ysb_school_id ||
                  item?.ysb_school_id ||
                  "",

                name_level:
                  kelas?.name_level ||
                  kelas?.["name level"] ||
                  assignment?.name_level ||
                  assignment?.["name level"] ||
                  "",

                nama_kelas:
                  kelas?.nama_kelas ||
                  kelas?.name_kelas ||
                  assignment?.name_kelas ||
                  assignment?.nama_kelas ||
                  "-",

                state_form:
                  assignment?.state_form ??
                  kelas?.state_form ??
                  1,

                raw: {
                  kelas,
                  assignment,
                },
              };
            }
          );

          const groupByLevel = kelasList.reduce(
            (acc, kelas) => {
              const levelKey =
                kelas?.name_level || "tanpa_level";

              if (!acc[levelKey]) {
                acc[levelKey] = [];
              }

              acc[levelKey].push(kelas);

              return acc;
            },
            {}
          );

          return Object.entries(groupByLevel).map(
            ([level, kelasByLevel]) => {
              const gradeLevelIds = [
                ...new Set(
                  kelasByLevel
                    .map(
                      (kelas) =>
                        kelas?.ysb_grade_level_id
                    )
                    .filter(Boolean)
                ),
              ];

              const kelasIds = [
                ...new Set(
                  kelasByLevel
                    .map(
                      (kelas) =>
                        kelas?.ysb_kelas_id
                    )
                    .filter(Boolean)
                ),
              ];

              const gradeLevelId =
                gradeLevelIds?.[0] || "";

              const totalSiswaGrade =
                rawTotalSiswaGrade.find(
                  (totalItem) =>
                    String(
                      totalItem?.ysb_grade_level_id || ""
                    ) === String(gradeLevelId || "")
                );

              const totalSiswa = Number(
                totalSiswaGrade?.total || 0
              );

              return {
                row_key: `${matpelId}-grade-${
                  gradeLevelId || level
                }`,

                id: matpelId,
                ysb_matpel_id: matpelId,

                ysb_grade_level_id:
                  gradeLevelId,

                selected_grade_level_ids:
                  gradeLevelIds,

                selected_kelas_ids: kelasIds,

                nama_matpel: namaMatpel,
                matpel_type: Number(item?.matpel_type ?? 0),
                name_level: level,

                nama_tingkatan:
                  level !== "tanpa_level"
                    ? `Kelas ${level}`
                    : "Tanpa Tingkatan",

                kelas_list: kelasByLevel,
                assignments: kelasByLevel,
                total_kelas: kelasByLevel.length,

                total_siswa: totalSiswa,

                raw: item,
              };
            }
          );
        }
      );

      setGetData(normalizedRows);
    } catch (error) {
      setGetData([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data ekstrakurikuler",
      });
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    getSemesterData();
  }, []);

  useEffect(() => {
    if (
      selectedSemesterId &&
      selectedAcademicYearId
    ) {
      getMatpelTeacherData({
        semesterId: selectedSemesterId,
        academicYearId:
          selectedAcademicYearId,
      });
    }
  }, [
    selectedSemesterId,
    selectedAcademicYearId,
  ]);

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = (searchKeyword || "")
      .trim()
      .toLowerCase();

    const base = !keyword
      ? getData || []
      : (getData || []).filter((item) => {
          const namaMatpel = (
            item?.nama_matpel || ""
          )
            .toString()
            .toLowerCase();

          const namaTingkatan = (
            item?.nama_tingkatan || ""
          )
            .toString()
            .toLowerCase();

          return (
            namaMatpel.includes(keyword) ||
            namaTingkatan.includes(keyword)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.nama_matpel || "")
          .toString()
          .trim(),
        (b?.nama_matpel || "")
          .toString()
          .trim()
      )
    );
  }, [
    getData,
    searchKeyword,
    nameCollator,
  ]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(
      totalRows / Math.max(1, rowsPerPage)
    );

    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;

    return filteredData.slice(
      start,
      start + safeRows
    );
  }, [
    filteredData,
    tablePage,
    rowsPerPage,
  ]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (
        let page = 1;
        page <= totalPages;
        page += 1
      ) {
        pages.push(page);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(
      totalPages,
      tablePage + 1
    );

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (
      let page = left;
      page <= right;
      page += 1
    ) {
      if (
        page !== 1 &&
        page !== totalPages
      ) {
        pages.push(page);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) =>
        array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const page = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(page);
  };

  const handleClickMatpel = (row) => {
    const selectedKelasIds = Array.isArray(
      row?.selected_kelas_ids
    )
      ? row.selected_kelas_ids
      : (row?.kelas_list || [])
          .map(
            (kelas) =>
              kelas?.ysb_kelas_id
          )
          .filter(Boolean);

    const selectedGradeLevelIds =
      Array.isArray(
        row?.selected_grade_level_ids
      )
        ? row.selected_grade_level_ids
        : [
            row?.ysb_grade_level_id,
          ].filter(Boolean);

    setSelectedMatpel({
      ...row,

      id:
        row?.ysb_matpel_id ||
        row?.id ||
        "",

      ysb_matpel_id:
        row?.ysb_matpel_id ||
        row?.id ||
        "",

      ysb_grade_level_id:
        row?.ysb_grade_level_id ||
        selectedGradeLevelIds?.[0] ||
        "",

      selected_grade_level_ids:
        selectedGradeLevelIds,

      selected_kelas_ids:
        selectedKelasIds,

      ysb_kelas_id:
        selectedKelasIds?.[0] || "",
    });

  };

  const handleBackToMatpel = () => {
    setSelectedMatpel(null);
  };

  const handleChangeSemester = (event) => {
    const semesterId = event.target.value;

    const semester = semesterOptions.find(
      (item) =>
        String(item?.id || "") === String(semesterId)
    );

    setSelectedSemesterId(semesterId);
    setSelectedAcademicYearId(
      semester?.ysb_academic_year_id || ""
    );
    setSelectedMatpel(null);
    setSearchKeyword("");
    setTablePage(1);
  };

  /*
   * Halaman detail ekstrakurikuler dibuat terpisah dari Home.
   * Tampilan list/card Home tetap seperti sebelumnya.
   */
  if (selectedMatpel) {
    return (
      <DetailEkskulPage
        selectedMatpel={selectedMatpel}
        selectedAcademicYearId={selectedAcademicYearId}
        selectedSemesterId={selectedSemesterId}
        getToken={getToken}
        getBranchId={getBranchId}
        getSchoolId={getSchoolId}
        onBack={handleBackToMatpel}
      />
    );
  }

  /*
   * Halaman list ekstrakurikuler.
   */
  return (
    <div className="body">
      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faBook} />
            </span>

            <h4 className="page-title-text">
              Ekstrakurikuler
            </h4>
          </div>
        </div>
      </div>

      <div className="body-content">
        <div
          className="d-flex mb-4"
          style={{
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            className="at-search"
            style={{
              flex: 1,
              minWidth: 240,
            }}
          >
            <input
              className="at-input"
              placeholder="Cari ekstrakurikuler"
              value={searchKeyword}
              onChange={(event) =>
                setSearchKeyword(
                  event.target.value
                )
              }
            />
          </div>

          <select
            className="at-input"
            value={selectedSemesterId}
            onChange={
              handleChangeSemester
            }
            style={{
              width: isTabletOrMobile
                ? "100%"
                : 260,
              cursor: "pointer",
              background: "#fff",
            }}
          >
            <option value="">
              Pilih Semester
            </option>

            {semesterOptions.map(
              (item) => (
                <option
                  key={item?.id}
                  value={item?.id}
                >
                  {getSemesterLabel(
                    item
                  )}

                  {Number(
                    item?.status
                  ) === 1
                    ? " - Aktif"
                    : ""}
                </option>
              )
            )}
          </select>
        </div>

        {isFetching ? (
          <div
            className="text-center"
            style={{
              padding: "30px 0",
            }}
          >
            <PulseLoader
              color="#3f5bea"
              size={10}
            />

            {/* <div
              style={{
                marginTop: 10,
                color: "#3f5bea",
                fontWeight: 400,
                fontSize: 16,
              }}
            >
              Memuat data mata
              pelajaran...
            </div> */}
          </div>
        ) : (
          <>
            {paginatedData.length > 0 ? (
              <div
                className="matpel-card-grid"
                style={{
                  display: "grid",

                  gridTemplateColumns:
                    isTabletOrMobile
                      ? "1fr"
                      : "repeat(2, minmax(0, 1fr))",

                  gap: 16,
                  maxWidth: "100%",
                }}
              >
                {paginatedData.map(
                  (row) => (
                    <div
                      key={row?.row_key}
                      className="matpel-card-item"
                      onClick={() =>
                        handleClickMatpel(
                          row
                        )
                      }
                      title="Klik untuk melihat detail ekstrakurikuler"
                      style={{
                        background: "#fff",
                        border:
                          "1px solid #e5e7eb",
                        borderRadius: 18,
                        padding: 18,
                        cursor: "pointer",
                        position: "relative",

                        boxShadow:
                          "0 10px 26px rgba(67, 104, 197, 0.08)",

                        transition:
                          "0.2s ease",
                      }}
                      onMouseEnter={(
                        event
                      ) => {
                        event.currentTarget.style.transform =
                          "translateY(-3px)";

                        event.currentTarget.style.boxShadow =
                          "0 16px 34px rgba(67, 104, 197, 0.14)";
                      }}
                      onMouseLeave={(
                        event
                      ) => {
                        event.currentTarget.style.transform =
                          "translateY(0)";

                        event.currentTarget.style.boxShadow =
                          "0 10px 26px rgba(67, 104, 197, 0.08)";
                      }}
                    >
                      {/* <div
                        className="d-flex"
                        style={{
                          alignItems:
                            "center",
                          gap: 12,
                        }}
                      > */}
                      <div
  className="d-flex"
  style={{
    alignItems: "center",
    gap: 12,
    paddingRight: isTabletOrMobile
      ? 85
      : 110,
  }}
>
                        <div
  style={{
    position: "absolute",
    top: 16,
    right: 16,

    display: "inline-flex",
    alignItems: "center",
    gap: 6,

    padding: "7px 11px",
    borderRadius: 10,

    background:
      "rgba(34, 197, 94, 0.10)",
    color: "#15803d",

    fontSize: 12,
    fontWeight: 700,
  }}
>
  <FontAwesomeIcon icon={faUsers} />

  {row?.total_siswa || 0} Siswa
</div>

                        <div
                          style={{
                            width: 44,
                            height: 44,
                            borderRadius: 14,

                            background:
                              "rgba(67, 104, 197, 0.12)",

                            color:
                              "#3f5bea",

                            display: "flex",

                            alignItems:
                              "center",

                            justifyContent:
                              "center",

                            fontSize: 18,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={
                              faBookOpen
                            }
                          />
                        </div>

                        <div
                          style={{
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              color:
                                "#111827",

                              fontWeight: 700,
                              fontSize: 15,
                              lineHeight: 1.3,
                            }}
                          >
                            {row?.nama_matpel ||
                              "-"}{" "}
                            -{" "}
                            {row?.nama_tingkatan ||
                              "-"}
                          </div>

                          <div
                            style={{
                              marginTop: 5,

                              color:
                                "#6b7280",

                              fontSize: 12,

                              fontWeight: 500,
                            }}
                          >
                            {semesterOptions.find(
                              (item) =>
                                String(
                                  item?.id ||
                                    ""
                                ) ===
                                String(
                                  selectedSemesterId
                                )
                            )
                              ? getSemesterLabel(
                                  semesterOptions.find(
                                    (
                                      item
                                    ) =>
                                      String(
                                        item?.id ||
                                          ""
                                      ) ===
                                      String(
                                        selectedSemesterId
                                      )
                                  )
                                )
                              : "-"}
                          </div>
                        </div>
                      </div>

                      <div
                        className="d-flex mt-4"
                        style={{
                          alignItems:
                            "center",

                          justifyContent:
                            "space-between",

                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",

                            alignItems:
                              "center",

                            gap: 6,

                            flexWrap:
                              "wrap",
                          }}
                        >
                          {row?.kelas_list
                            ?.length > 0 ? (
                            row.kelas_list.map(
                              (
                                kelas,
                                kelasIndex
                              ) => (
                                <span
                                  key={
                                    kelas?.ysb_kelas_id ||
                                    kelasIndex
                                  }
                                  style={{
                                    display:
                                      "inline-flex",

                                    alignItems:
                                      "center",

                                    gap: 6,

                                    padding:
                                      "6px 10px",

                                    borderRadius: 999,

                                    background:
                                      "#f3f4f6",

                                    color:
                                      "#374151",

                                    fontSize: 12,

                                    fontWeight: 700,
                                  }}
                                >
                                  {kelas?.nama_kelas ||
                                    "-"}
                                </span>
                              )
                            )
                          ) : (
                            <span
                              style={{
                                display:
                                  "inline-flex",

                                alignItems:
                                  "center",

                                gap: 6,

                                padding:
                                  "6px 10px",

                                borderRadius: 999,

                                background:
                                  "#fee2e2",

                                color:
                                  "#b91c1c",

                                fontSize: 12,

                                fontWeight: 700,
                              }}
                            >
                              <FontAwesomeIcon
                                icon={
                                  faChalkboardTeacher
                                }
                              />

                              Belum ada kelas
                            </span>
                          )}
                        </div>

                        <span
                          style={{
                            fontSize: 12,

                            color:
                              "#3f5bea",

                            fontWeight: 700,

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Lihat Detail →
                        </span>
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  padding:
                    "40px 20px",

                  background: "#fff",

                  borderRadius: 16,

                  border:
                    "1px dashed #cbd5e1",

                  color: "#6b7280",

                  fontWeight: 600,
                }}
              >
                Data ekstrakurikuler
                tidak ditemukan
              </div>
            )}

            {filteredData.length > 0 && (
              <div className="at-pagination mt-4">
                <div
                  className="d-flex"
                  style={{
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  <span className="at-page-info">
                    Menampilkan{" "}
                    <b>
                      {Math.min(
                        (tablePage - 1) *
                          rowsPerPage +
                          1,
                        totalRows
                      )}
                    </b>
                    -
                    <b>
                      {Math.min(
                        tablePage *
                          rowsPerPage,
                        totalRows
                      )}
                    </b>{" "}
                    dari{" "}
                    <b>{totalRows}</b>{" "}
                    data
                  </span>

                  <select
                    className="at-page-size"
                    value={rowsPerPage}
                    onChange={(event) => {
                      const value =
                        Number(
                          event.target
                            .value
                        ) || 10;

                      setRowsPerPage(
                        value
                      );

                      setTablePage(1);
                    }}
                  >
                    <option value={10}>
                      10 / halaman
                    </option>

                    <option value={25}>
                      25 / halaman
                    </option>

                    <option value={50}>
                      50 / halaman
                    </option>

                    <option value={100}>
                      100 / halaman
                    </option>
                  </select>
                </div>

                <div
                  className="d-flex"
                  style={{
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    className="at-page-btn"
                    onClick={() =>
                      goToPage(
                        tablePage - 1
                      )
                    }
                    disabled={
                      tablePage <= 1
                    }
                  >
                    Prev
                  </button>

                  <div className="at-page-numbers">
                    {pageNumbers.map(
                      (page, index) =>
                        page === "..." ? (
                          <span
                            key={`dots-${index}`}
                            className="at-page-info"
                            style={{
                              padding:
                                "0 6px",
                            }}
                          >
                            ...
                          </span>
                        ) : (
                          <button
                            type="button"
                            key={`page-${page}`}
                            className={`at-page-number ${
                              page ===
                              tablePage
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              goToPage(
                                page
                              )
                            }
                          >
                            {page}
                          </button>
                        )
                    )}
                  </div>

                  <button
                    type="button"
                    className="at-page-btn"
                    onClick={() =>
                      goToPage(
                        tablePage + 1
                      )
                    }
                    disabled={
                      tablePage >=
                      totalPages
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}